import resetPasswordModel from '../../models/reset-password.model';
import passwordChecker from '../../utils/password-checker';
import ViewBase from '../view-base.view';

export default function ResetPasswordView() {
  //This view is used after user clicked forget password and user click link from email, it will redirect to this view to reset password.
  ViewBase.call(this);

  let resetCredentials = { password: '', reset_token: '', confirmPassword: '' };
  var submitted = false;
  var invalid = false;
  let passwordValidatorList = [];

  const resetPassword = (e) => {
    e.preventDefault();
    submitted = true;

    if (!resetCredentials.confirmPassword || !resetCredentials.password || !resetCredentials.reset_token) return;

    if (resetCredentials.password != resetCredentials.confirmPassword) {
      invalid = true;
      return;
    }

    resetPasswordModel.resetPassword(
      resetSuccessCallBack,
      resetFailureCallBack,
      resetCredentials.password,
      resetCredentials.reset_token
    )
  }

  const resetSuccessCallBack = () => {
    submitted = false;
    this.showMessage('Password has been changed. Please login.', null, () => {
      m.route.set("/login");
    });
  }

  const resetFailureCallBack = (error) => {
    submitted = false;
    this.handleError(error);
  }

  const setPassword = (e) => {
    resetCredentials.password = e.target.value;
    passwordValidatorList = passwordChecker.check(e.target.value, "", false)["validateMessages"];
  }

  const setConfirmPassword = (e) => {
    resetCredentials.confirmPassword = e.target.value
  }

  const getTokenFromURL = () => {
    var reset_token = location.href.split("token=")[1];

    if (reset_token) {
      resetCredentials.reset_token = reset_token;
    } else {
      this.showErrorMessage('Missing token. Please request for password reset link again.', null, () => {
        m.route.set("/forgot");
      });
    }
  }

  return {
    view: () => {
      getTokenFromURL();
      return [
        m('.d-flex',
          m('.reset-password-main-container',
            m('.container-fluid.py-3',
              m('.row',
                m('.col-md-12',
                  m('.p-3',
                    m('div',
                      [
                        m('div', { "class": "card" },
                          m('div', { "class": "card-body pt-0" },
                            m('div', { "class": "row  justify-content-center_" },
                              m('div', { "class": "col-md-12" },
                                m('div', { "class": "row  mb-2" },
                                  m('form.card-body', { onsubmit: resetPassword }, [
                                    m('h3.mb-4.text-center', 'Reset Password'
                                    ),

                                    submitted && invalid &&
                                    m(
                                      'div', { "class": "invalid-feedback fs-6", style: 'display:block;' },
                                      m('small', 'New Password and Confirm Password must be same!')
                                    ),
                                    m('div', { "class": "form-group mb-4" },
                                      m("label.form-label", "Password"),
                                      m(
                                        "input[type='password'][placeholder='Password'].form-control",
                                        { onkeyup: setPassword }
                                      )
                                    ),
                                    submitted && !resetCredentials.password &&
                                    m(
                                      'div', { "class": "invalid-feedback fs-6", style: 'display:block;' },
                                      m('small', 'Password is required')
                                    ),
                                    passwordValidatorList.map(error =>
                                      [
                                        !error.isValid && m('div', { "class": "invalid-feedback fs-6 d-block" },
                                          m('i.bi.bi-x-square.mr-6'),
                                          m('small', error.message)
                                        ),
                                        error.isValid && m('div', { "class": "valid-feedback fs-6 d-block" },
                                          m('i.bi.bi-check2-square.mr-6'), m('small', error.message)
                                        )
                                      ]),
                                    m('div', { "class": "form-group mb-4" },
                                      m("label.form-label", "Confirm Password"),
                                      m(
                                        "input[type='password'][placeholder='Password'].form-control",
                                        { onchange: setConfirmPassword }
                                      )
                                    ),
                                    submitted && !resetCredentials.confirmPassword &&
                                    m(
                                      'div', { "class": "invalid-feedback fs-6", style: 'display:block;' },
                                      m('small', 'Confirm Password is required')
                                    ),
                                    m('div.text-center',
                                      m(
                                        "button.btn.btn-primary[type='submit']",
                                        'Submit'
                                      )
                                    )
                                  ])

                                )
                              )
                            )
                          )),
                      ])
                  )
                )
              )
            )
          )
        ),
        this.getBaseViews()
      ];
    }
  }
}
